import React, {Fragment, PureComponent} from 'react'
import get from 'lodash/get'
import Helmet from 'react-helmet'
import PageLayout from './PageLayout'
import { SECTIONS } from './../../utils/url'
import { withPopupContext } from '../../contexts'
import Popup from './../common/Popup'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import richTextReactRendering from '../../utils/richTextReactRendering';

const externalScript = ['/scripts/dist/gest-age.nomodule.js', '/scripts/dist/gest-age.module.js'];
class Calculator extends PureComponent {
    constructor(props) {
        super(props)

        this.state = {
            showDisclaimer: false
        }

        this.scripts = [];

        const code = get(this.props.calculator, 'html');
        if(code) {
            this.REGEX = {
                OPEN_SCRIPT: `<script[^>]*>`,
                SOMETHING: `([\\s\\S]+?)`, // eslint-disable-line no-useless-escape
                CLOSED_SCRIPT: `<\\/script>`, // eslint-disable-line no-useless-escape
            }
            this.REGEX.SCRIPT_TAGS = new RegExp(this.REGEX.OPEN_SCRIPT + this.REGEX.SOMETHING + this.REGEX.CLOSED_SCRIPT, 'gi');
            const {html, scripts} = this.separateHTMLandScript(code)
        
            this.scripts = scripts;

            this.state.html = html;
        }
    }

    componentDidMount() {
        this.importCalculatorScripts(this.props.calculator.name);
        this.scripts.forEach(script => {
            try {
                window.eval(script); // eslint-disable-line no-eval
            } catch (err) {
                console.error(`Error on calculator ${this.props.calculator.name}: ${err}`)
                console.log(script)
            }
        })
        this.initialiseForm()
    }

    importCalculatorScripts(name){
        if(name === 'Gestation Calculator'){
            externalScript.map(script => {
                this.loadScript(script);
            });
        }
    }

    loadScript(src){
        try {
            let myScript = document.createElement('script');
            myScript.src = src;
            myScript.async = true;
            document.body.appendChild(myScript);
        } catch (err) {
            console.error(`Error on calculator load ${src} for ${this.props.calculator.name}: ${err}`)
        }
    }

    componentWillUnmount() {
        externalScript.map(script => {
            this.removeScript(script);
        });
    }

    removeScript(scriptToremove){
        let allsuspects = document.getElementsByTagName("script");
        for (let i=allsuspects.length; i>=0; i--){
        if (allsuspects[i] && allsuspects[i].getAttribute("src")!==null 
            && allsuspects[i].getAttribute("src").indexOf(`${scriptToremove}`)!== -1 ){
                allsuspects[i].parentNode.removeChild(allsuspects[i])
            }
        }
    }

    /**
     * This is basically a hack. Don't shoot! Let me explain:
     * The calculators' HTML has inline style. Some to show (horrible) colors and other’s to initialise fields as "display:none;"
     * We are getting rid of all the inline styles but that left us with the problem of all the fields being shown and some (hopefully most?) of the calculators have a ClearScripts function that initialises the fields.
     * So whenever possible we call this function after the form is rendered.
     */
    initialiseForm() {
        window.ClearScripts && window.ClearScripts()
    }


    separateHTMLandScript(code) {
        // Get all script tags (not just their content)
        const scriptTags = code.match(this.REGEX.SCRIPT_TAGS) || []

        const html = this.getBodyContent(code)

        const scripts = scriptTags.map(script => {
            // Remove the <script> </script> tags and leave only the content
            return script
                .replace(new RegExp(this.REGEX.OPEN_SCRIPT, 'i'), '')
                .replace(new RegExp(this.REGEX.CLOSED_SCRIPT, 'i'), '')
                .replace('<!--', '')
                .replace('-->', '')
                .trim()
        })

        return {
            html,
            scripts,
        }
    }

    getBodyContent(code) {
        const body = code
            .replace(new RegExp(this.REGEX.OPEN_SCRIPT + this.REGEX.SOMETHING + this.REGEX.CLOSED_SCRIPT, 'gi'), '')
            .match(new RegExp('<body[^>]*>([\\s\\S]+?)<\\/body>', 'gi'));
        if(!body) {
            console.error(`There is an error with the calculator ${this.props.calculator.name} html. Please make sure you have matching <body> and </body> tags.`)
            return `There is an error with the calculator's code. Please make sure you have matching <body> and </body> tags.`
        }
        const html = body ? body[0] : code;
        return html
            .replace(/<body[^>]*>/gi, '')
            .replace(/<\/body>/gi, '')
            .trim()
    }

    toggleDisclaimer = () => {
        this.setState(prevState => ({
            showDisclaimer: !prevState.showDisclaimer,
        }))
    }

    render() {
        const { calculator, sitemap } = this.props
        const information = get(calculator, 'information.childContentfulRichText.internal.content')
        const disclaimer = get(calculator, 'disclaimer.content.childContentfulRichText.html', '')
        const metaDescription = get(calculator, 'metaDescription.metaDescription')
        const searchable = get(calculator, 'searchable')
        const { html, showDisclaimer } = this.state

        return (
            <PageLayout className="calculator-page" activeSection={SECTIONS.HEALTH_PROFESSIONALS.key} sitemap={sitemap}>
                <Helmet>
                    <title>{calculator.name} calculator</title>
                    {!!metaDescription && <meta name="description" content={metaDescription} />}
                    {!searchable && <meta name="robots" content="noindex" />}
                </Helmet>
                <Fragment>
                    <main className="wrapper">
                        <h1 className="section-headline">{calculator.name}</h1>

                        {!!disclaimer && <div className="disclaimer mb-2">
                            This document is only valid for the day on which it is accessed. Please read our <button className="as-link" onClick={this.toggleDisclaimer}>disclaimer</button>.
                        </div>}
                        <div className="richtext-body">
                            {information && documentToReactComponents(JSON.parse(information), richTextReactRendering)}
                        </div>
                        <section className="calculator-content content box-shadow ">
                            {html ? <div dangerouslySetInnerHTML={{
                                __html: html
                            }}/> : <p>We could not find a script for this calculator. Please get in contact with us so we can work this out.</p>}
                        </section>
                    </main>

                    {showDisclaimer && (
                        <Popup title={'Disclaimer'} className="primary" onClose={this.toggleDisclaimer}>
                            <p dangerouslySetInnerHTML={{
                                __html: disclaimer
                            }}/>
                        </Popup>
                    )}
                </Fragment>
            </PageLayout>
        )
    }
}

export default withPopupContext(Calculator)